/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Divider, Header } from 'semantic-ui-react'
import { PositiveActivityCard } from './Cards/PositiveActivityCard'
import { NegativeActivityCard } from './Cards/NegativeActivityCard/NegativeActivityCard'
import { UnavailableItemsSummaryCard } from './Cards/UnavailableItemsSummaryCard'
import { Section } from '../Shared/Section'
import { NextClosureCard } from './Cards/NextClosureCard'
import { BusyModeDurationCard } from './Cards/BusyModeDurationCard'
import { useDeviceMediaQuery } from '../../Shared/UseDeviceMediaQuery/useDeviceMediaQuery'
import useUser from '../../Shared/UserProvider/useUser'
import { isProviderAPos } from '../../../services/Provider/Provider.service'
import { TopProductsCard } from './Cards/TopProductsCard/TopProductsCard'

const TodayActivitySection = () => {
    const {user} = useUser()
    const {isMobile} = useDeviceMediaQuery()

    return (
      <>
          <Divider horizontal>
              <Header horizontal as="h4" color="teal">
                  Activité du jour
              </Header>
          </Divider>

          <Section $isMobile={isMobile}>
              <PositiveActivityCard/>
              <NegativeActivityCard/>
              <UnavailableItemsSummaryCard/>
              {isProviderAPos(user.provider) && (
                <div
                  css={css`
                      display: flex;
                      flex-direction: column;
                      justify-content: space-between;
                      height: 210px;
                      gap: 1rem;
                  `}
                >
                    <NextClosureCard/>
                    <BusyModeDurationCard/>
                </div>
              )}
              <TopProductsCard />
          </Section>
      </>
    )
}

export { TodayActivitySection }
